import React, { Component } from "react";
import $ from "jquery";
import SlideQuran from "../../MyFiles/Slide/Slide6.jpg";

class Quran extends Component {
  constructor(props) {
    super(props);
    this.getQuranType = this.getQuranType.bind(this);
  }
  state = {
    userQuranTypeJson: [],
    userCompetitionRequestJson: [],
    errorMessage: "",
    stepNo: 1,
    isRegister: true,
  };
  componentDidMount() {
    this.getQuranRequest();
    this.getQuranType();
  }
  toggleRegister = () => {
    this.setState({ isRegister: !this.state.isRegister });
  };
  toggleEdit = () => {
    this.props.getAllUserRelation();
    this.setState({ stepNo: 2 });
    this.setState({ isRegister: !this.state.isRegister });
  };
  toggleSubmit = () => {
    if (this.state.stepNo === 1) {
      this.getQuranType();
      this.props.getAllUserRelation();
      this.setState({ stepNo: 2 });
    }
    if (this.state.stepNo === 2) {
      this.props.getAllUserRelation();
      this.setState({ stepNo: 3 });
    }
    if (this.state.stepNo === 3) {
      this.submitForm();
    }
  };
  toggledecline = () => {
    if (this.state.stepNo === 1) {
      this.setState({ isRegister: !this.state.isRegister });
    }
    if (this.state.stepNo === 2) {
      this.setState({ stepNo: 1 });
    }
    if (this.state.stepNo === 3) {
      this.setState({ stepNo: 2 });
    }
  };
  selectRelation = (id, e) => {
    if (id !== null) {
      var cusid_ele = document.getElementsByClassName("dvCandidate");
      for (var i = 0; i < cusid_ele.length; ++i) {
        var item = cusid_ele[i];
        var dvQuranType = document.getElementById("dvQuranType_" + id);
        var getValue = $(item).attr("data-target");
        if (getValue !== null && getValue.includes(id)) {
          item.classList.toggle("active");
          dvQuranType.classList.toggle("hide");
        }
      }
    }
  };
  submitForm = () => {
    var errorMessage = "مجدد وارد سامانه شوید، نشست شما به پایان رسیده است.";
    const token = localStorage.getItem("token");
    if (token !== null) {
      var SendRequest = false;
      var selectRelationID = 0;
      var SelectRelationTypeID = 0;
      var cusid_ele = document.getElementsByClassName("dvCandidate");
      if (cusid_ele.length !== 0) {
        for (var i = 0; i < cusid_ele.length; ++i) {
          var item = cusid_ele[i];
          if (item.classList.contains("active") === true) {
            var Value = $(item).attr("data-target");
            selectRelationID =
              selectRelationID === 0
                ? (selectRelationID = Value)
                : (selectRelationID = selectRelationID + "," + Value);
            var FisrtType = document.getElementById(Value + "_FirstType").value;
            var SecondType = document.getElementById(Value + "_SecondType")
              .value;
            var QuranTypeString = null;
            if (FisrtType === null || FisrtType === "") {
              errorMessage = "انتخاب حداقل یک رشته برای هر نفر الزامی است.";
              this.props.toggleErrorMessage(errorMessage);
              this.props.toggleError();
              break;
            } else {
              QuranTypeString = FisrtType;
            }
            if (SecondType > 0) {
              if (FisrtType === SecondType) {
                errorMessage = "رشته اول و دوم انتخابی نمی‌تواند یکسان باشد.";
                this.props.toggleErrorMessage(errorMessage);
                this.props.toggleError();
                break;
              }
              QuranTypeString = QuranTypeString + "_" + SecondType;
            }
            SelectRelationTypeID =
              SelectRelationTypeID === 0
                ? (SelectRelationTypeID = QuranTypeString)
                : (SelectRelationTypeID =
                    SelectRelationTypeID + "," + QuranTypeString);
          }
          if (i === cusid_ele.length - 1) {
            SendRequest = true;
          }
        }
      }
      if (selectRelationID === 0) {
        errorMessage = "شرکت کنندگان در مسابقه را انتخاب نمایید.";
        this.props.toggleErrorMessage(errorMessage);
        this.props.toggleError();
      } else {
        if (SendRequest === true) {
          var formdata = new FormData();
          formdata.append("token", token);
          formdata.append("ID_Relation", selectRelationID);
          formdata.append("ID_RelationQuranType", SelectRelationTypeID);
          formdata.append("CompetitionRequestTypeRef", 4);

          var requestOptions = {
            method: "POST",
            body: formdata,
            redirect: "follow",
          };

          fetch(
            `${process.env.REACT_APP_BASE_API_URL}/api/user/submit-quran`,
            requestOptions
          )
            .then((response) => response.text())
            .then((result) => {
              if (result !== null) {
                var myObject = JSON.parse(result);
                if (myObject.status === 0) {
                  this.getQuranRequest();
                  errorMessage = "درخواست شما با موفقیت در سامانه ثبت شد.";
                  this.props.toggleErrorMessage(errorMessage);
                  this.props.toggleError();
                  this.toggleRegister();
                } else {
                  errorMessage = myObject.message;
                  this.props.toggleErrorMessage(errorMessage);
                  this.props.toggleError();
                }
              }
            })
            .catch((error) => console.log("error", error));
        }
      }
    } else {
      this.props.toggleErrorMessage(errorMessage);
      this.props.toggleError();
    }
  };
  handleRequest = (e) => {
    this.declineRequest(e);
  };
  declineRequest = (e) => {
    //console.log("APP-Get User Request");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("ID_Request", e);
      formdata.append("CompetitionRequestTypeRef", 4);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/del-user-competition-request`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            // console.log(result);
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.getQuranRequest();
            } else {
              const errorMessage = myObject.message;
              this.props.toggleErrorMessage(errorMessage);
              this.props.toggleError();
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getQuranType = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/get-quran-type`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ userQuranTypeJson: myObject.data }, function() {
                console.log(this.state.userQuranTypeJson);
              });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getQuranRequest = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("CompetitionRequestTypeRef", 4);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/get-user-competition-request`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState(
                { userCompetitionRequestJson: myObject.data },
                function() {
                  console.log(this.state.userCompetitionRequestJson);
                }
              );
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  render() {
    const QuranType = this.state.userQuranTypeJson.map((myList) => (
      <option key={myList.ID} value={myList.ID}>
        {myList.Title}
      </option>
    ));
    const Relation_Active = this.props.userRelationsJson
      .filter((ee) => ee.Relation_ID === 10 || ee.Relation_ID === 11)
      .map((e) =>
        e.NeedEdit !== true ? (
          <div
            key={e.ID}
            className="col-12 mb-2 bg-light dvCandidate"
            data-target={e.ID}
          >
            <div className="w-100 rounded p-1">
              <div className="row">
                <div className="col-2 m-auto checkbox">
                  <label className="containerCustom">
                    <input
                      type="checkbox"
                      value={e.ID}
                      onClick={() => this.selectRelation(e.ID, this)}
                      name="Candidate"
                    ></input>
                    <span className="checkmark"></span>
                  </label>
                  {/* <input type="radio" name='Candidate'  /> */}
                </div>
                <div className="col-10 p-2">
                  <span className="bg-dark text-white wp-text-small rounded px-2 py-0">
                    جنسیت: {e.Sex}
                  </span>{" "}
                  <span className="bg-dark text-white wp-text-small rounded px-2 py-0 mr-2">
                    نسبت: {e.Relation_Title}
                  </span>
                  <div className="title mt-1">
                    کدملی: <b>{e.National_Code}</b>
                  </div>
                  <div className="title mt-1">
                    <strong>
                      {e.F_Name} {e.L_Name}
                    </strong>
                  </div>
                </div>
              </div>
              <div id={"dvQuranType_" + e.ID} className="row hide mt-2">
                <div className="col-6">
                  <label className="wp-text-sm font-weight-bold">
                    رشته اول
                    <abbr className="text-danger font-weight-bold">*</abbr>
                  </label>
                  <select
                    id={e.ID + "_FirstType"}
                    name="QuranType"
                    className="form-select leftArrow"
                  >
                    <option value="">انتخاب نمایید</option>
                    {QuranType}
                  </select>
                </div>
                <div className="col-6">
                  <label className="wp-text-sm font-weight-bold">
                    رشته دوم
                  </label>
                  <select
                    id={e.ID + "_SecondType"}
                    name="QuranType"
                    className="form-select leftArrow"
                  >
                    <option value="">انتخاب نمایید</option>
                    {QuranType}
                  </select>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            key={e.ID}
            className="col-12 mb-2 bg-light dvRelation disable"
            data-target={e.ID}
          >
            <div className="w-100 rounded p-1">
              <span className="bg-dark text-white wp-text-small rounded px-2 py-0">
                جنسیت: {e.Sex}
              </span>{" "}
              <span className="bg-dark text-white wp-text-small rounded px-2 py-0 mr-2">
                نسبت: {e.Relation_Title}
              </span>
              <div className="title mt-1">
                <strong>
                  {e.F_Name} {e.L_Name}
                </strong>
              </div>
              <div className="describe">
                کدملی: <b>{e.National_Code}</b>
              </div>
              <span className="bg-danger text-white wp-text-small px-2">
                عدم امکان انتخاب به دلیل نقص در اطلاعات فرد
              </span>
            </div>
          </div>
        )
      );
    const myRelation = this.props.userRelationsJson
      .filter((ee) => ee.Relation_ID === 10 || ee.Relation_ID === 11)
      .map((e) => (
        <li key={e.ID} className={"Array-item readClass"}>
          <span className="bg-dark text-white wp-text-small rounded p-1">
            جنسیت: {e.Sex}
          </span>{" "}
          <span className="bg-dark text-white wp-text-small rounded p-1 mr-2">
            نسبت: {e.Relation_Title}
          </span>
          <div className="title mt-1">
            <strong>
              {e.F_Name} {e.L_Name}
            </strong>
          </div>
          <div className="describe">
            کدملی: <b>{e.National_Code}</b>
          </div>
          <div className="describe">
            ش.شناسنامه: <b>{e.Identity_Code}</b>
          </div>
          <div className="describe">
            تاریخ تولد: <b>{e.DateOfBirthday}</b>
          </div>
          <div className="describe">
            محل صدور: <b>{e.Sodor_City}</b>
          </div>
          <div className="text-left">
            <span className={e.State_CSS}>{e.State_Title}</span>
          </div>
          {e.NeedEdit === true ? (
            <React.Fragment>
              <span className="bg-danger text-white wp-text-small">
                اطلاعات این فرد ناقص است، لطفاً نسبت به تکمیل اطلاعات فرد اقدام
                نمایید.
              </span>
              <div className="text-left">
                <button
                  type="button"
                  onClick={() => this.props.getUserRelation(e.ID)}
                  className="btn btn-warning btn-sm rounded-0 py-0 px-1 small-font"
                >
                  ویرایش
                </button>
              </div>
            </React.Fragment>
          ) : null}
        </li>
      ));
    const myRequest = this.state.userCompetitionRequestJson.map((e) => (
      <li key={e.ID} className={"Array-item readClass"}>
        <span className="bg-dark text-white wp-text-small rounded p-1">
          تاریخ درخواست {e.RequestTime}
        </span>
        <div className="title mt-2">
          <strong>{e.Comment}</strong>
        </div>
        {/* <div className='d-grid mb-2'>
                    <span className='bg-success text-white px-2 py-1 wp-text'>{(e.Start_Date !== null) ? <span className='wp-text-small'>از </span> : <span></span>}<b>{e.Start_Date}</b></span>
                    {(e.End_Date !== null) ? <span className='bg-danger text-white px-2 py-1 wp-text'><span className='wp-text-small'>تا </span><b>{e.End_Date}</b></span> : <span></span>}
                </div> */}
        <div className="bg-primary text-white px-2 py-1 wp-text mt-2">
          تعداد شرکت‌کنندگان: <b>{e.Count}</b>
        </div>
        <div className="describe mt-2">
          {e !== null &&
          e.data_addition !== null &&
          e.data_addition.length > 0 &&
          e.Count > 0
            ? e.data_addition.map((ee) => {
                return (
                  <div key={ee.ID}>
                    <p className="mb-1">
                      <span className="badge bg-success p-2"> </span>{" "}
                      {ee.full_name} ({ee.Relation_Title})
                    </p>
                    <p>
                      {ee.details !== null ? (
                        <span className="bg-success text-white wp-text-small p-1">
                          رشته اول: {ee.details} {""}
                        </span>
                      ) : null}
                      {ee.subdetails !== null ? (
                        <span className="bg-success text-white wp-text-small mr-2 p-1">
                          رشته دوم: <span>{ee.subdetails}</span>
                        </span>
                      ) : null}
                    </p>
                  </div>
                );
              })
            : null}
        </div>
        <div className="text-right mb-2">
          <span className="text-success btn-sm rounded-pill font-weight-bold">
            وضعیت درخواست: ثبت شده
          </span>
        </div>
        {e.State === "1" ? (
          <div className="text-left">
            <button
              type="button"
              onClick={() => this.handleRequest(e.ID)}
              className="btn btn-danger btn-sm rounded-pill py-1 px-3 small-font"
            >
              انصراف
            </button>
          </div>
        ) : null}
      </li>
    ));
    if (this.state.isRegister === true) {
      return (
        <React.Fragment>
          <div className="w-100 body-padding">
            <p className="wp-header small">درخواست‌های ثبت شده قبلی</p>
            <ul className="Array p-0 mb-5">
              {myRequest.length === 0 ? (
                <li className="Array-item">
                  <div className="title">
                    هنوز درخواستی توسط شما ثبت نشده است.
                  </div>
                </li>
              ) : (
                myRequest
              )}
            </ul>
            {myRequest.length === 0 ? (
              <button
                onClick={this.toggleRegister}
                className="btn btn-success wp-button-add"
              >
                <span>ثبت‌نام در مسابقه</span>
              </button>
            ) : (
              <button
                onClick={this.toggleEdit}
                className="btn btn-primary wp-button-add"
              >
                <span>ویرایش درخواست</span>
              </button>
            )}
          </div>
        </React.Fragment>
      );
    } else {
      if (this.state.stepNo === 1) {
        return (
          <React.Fragment>
            <div className="w-100 body-padding">
              <div className="text-left">
                <p className="wp-header text-center">
                  «قرآن را نیکو تلاوت کنید؛ زیرا که آن، سودمندترین داستان
                  (تاریخ) است و از آن شفا جویید؛ زیرا که آن شفای سینه‌هاست.»
                </p>
                <small className="text-left font-weight-bold wp-small">
                  امام علی (ع)
                </small>
              </div>
              <div className="row justify-content-center">
                <p className="text-center font-weight-bold"></p>
                <div className="col-12 mb-2">
                  <React.Fragment>
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      className="wp-link"
                      href="https://refapi.salcocomplex.com/FileStorage/CM_Image/Quran/AVCDFEPE-1.pdf"
                    >
                      <img
                        className="w-100"
                        src={SlideQuran}
                        alt="مسابقات قرآن‌کریم"
                      ></img>
                    </a>
                  </React.Fragment>
                </div>
                <div className="col-12 mb-2">
                  <p className="text-center">
                    قبل از ثبت‌نام در مسابقات قرآن کریم آئین‌نامه اجرایی را از
                    طریق لینک زیر دریافت و آن را کامل مطالعه نمایید.{" "}
                  </p>
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    className="btn btn-primary w-100"
                    href="https://refapi.salcocomplex.com/FileStorage/CM_Image/Quran/AVCDFEPE-1.pdf"
                  >
                    دانلود آئین‌نامه
                  </a>
                </div>
                <div className="col-12 text-left">
                  <button
                    onClick={this.toggledecline}
                    className="btn btn-sm btn-danger"
                  >
                    <span>انصراف</span>
                  </button>
                  <button
                    onClick={this.toggleSubmit}
                    className="btn btn-sm btn-success mr-2"
                  >
                    <span>ادامه</span>
                  </button>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      } else if (this.state.stepNo === 2) {
        return (
          <React.Fragment>
            <div className="w-100 body-padding">
              <div class="alert alert-warning p-2 my-2">
                <i class="fa fa-info font-weight-bold"></i>
                <strong>پیغام!</strong>
                <p class="text-justify mb-0">
                  با توجه به آئین‌نامه، حضور در این مسابقات برای همسر و فرزندان
                  پرسنل مجاز می&zwnj;باشد.
                </p>
                <p class="text-center font-weight-bold">
                  در صورتی که اطلاعات همسر و فرزندان شما ناقص است آن را تکمیل و
                  در مرحله بعد برای حضور در جشن انتخاب نمایید.
                </p>
                <div className="text-left">
                  <button
                    onClick={this.props.toggleRelation}
                    className="btn btn-sm btn-primary"
                  >
                    <span>+ افزودن</span>
                  </button>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-12">
                  <ul className="Array p-0 mb-2">
                    {myRelation.length === 0 ? (
                      <li className="Array-item">
                        <div className="title">
                          اطلاعات اعضای خانوار شما در سامانه ثبت نشده است.
                        </div>
                      </li>
                    ) : (
                      myRelation
                    )}
                  </ul>
                  <div className="text-left">
                    <button
                      onClick={this.toggledecline}
                      className="btn btn-sm btn-danger"
                    >
                      <span>بازگشت</span>
                    </button>
                    <button
                      onClick={this.toggleSubmit}
                      className="btn btn-sm btn-success mr-2"
                    >
                      <span>تایید و ادامه</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      } else if (this.state.stepNo === 3) {
        return (
          <React.Fragment>
            <div className="w-100 body-padding">
              <p class="wp-header bg-primary my-1 text-white text-center">
                انتخاب شرکت کنندگان
              </p>
              <div className="alert alert-info p-1 my-2">
                <p className="mb-0">
                  بعد از انتخاب شخص، حداقل 1 و حداکثر 2 رشته را انتخاب کنید.
                </p>
              </div>
              <div className="row justify-content-center">
                <div className="col-12">
                  <ul className="Array p-0 mb-2 list-group">
                    <li className="list-group-item ">
                      <div
                        key={this.props.userJson.id}
                        className="col-12 mb-2 bg-light dvCandidate"
                        data-target={this.props.userJson.id}
                      >
                        <div className="w-100 rounded p-1">
                          <div className="row">
                            <div className="col-2 m-auto checkbox">
                              <label className="containerCustom">
                                <input
                                  type="checkbox"
                                  value={this.props.userJson.id}
                                  onClick={() =>
                                    this.selectRelation(
                                      this.props.userJson.id,
                                      this
                                    )
                                  }
                                  name="Candidate"
                                ></input>
                                <span className="checkmark"></span>
                              </label>
                              {/* <input type="radio" name='Candidate'  /> */}
                            </div>
                            <div className="col-10 p-2">
                              <span className="bg-success text-white wp-text-small rounded px-2 py-0">
                                نسبت: نفر اصلی
                              </span>
                              <div className="title mt-1">
                                کدملی: <b>{this.props.userJson.national_id}</b>
                              </div>
                              <div className="title mt-1">
                                <b>{this.props.userJson.full_name}</b>
                              </div>
                            </div>
                          </div>
                          <div
                            id={"dvQuranType_" + this.props.userJson.id}
                            className="row hide mt-2"
                          >
                            <div className="col-6">
                              <label className="wp-text-sm font-weight-bold">
                                رشته اول
                                <abbr className="text-danger font-weight-bold">
                                  *
                                </abbr>
                              </label>
                              <select
                                id={this.props.userJson.id + "_FirstType"}
                                name="QuranType"
                                className="form-select leftArrow"
                              >
                                <option value="">انتخاب نمایید</option>
                                {QuranType}
                              </select>
                            </div>
                            <div className="col-6">
                              <label className="wp-text-sm font-weight-bold">
                                رشته دوم
                              </label>
                              <select
                                id={this.props.userJson.id + "_SecondType"}
                                name="QuranType"
                                className="form-select leftArrow"
                              >
                                <option value="">انتخاب نمایید</option>
                                {QuranType}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      {Relation_Active.length === 0 ? null : Relation_Active}
                    </li>
                  </ul>
                  <div className="text-left">
                    <button
                      onClick={this.toggledecline}
                      className="btn btn-sm btn-danger"
                    >
                      <span>بازگشت</span>
                    </button>
                    <button
                      onClick={this.toggleSubmit}
                      className="btn btn-sm btn-success mr-2"
                    >
                      <span>ثبت نهایی درخواست</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      }
    }
  }
}
export default Quran;
